var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',_vm._l((_vm.$store.state.products),function(product){return _c('v-col',{key:product.name,attrs:{"sm":"6","md":"4"}},[_c('VerticalProduct',{attrs:{"product":product,"addToCart":_vm.addToCart}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }